<template>
  <div class="endemicPlantInfo">
    <div class="endemicPlantInfo-lg">
      <el-descriptions class="margin-top" :title="this.title + '详情'" style="text-align: center"  :column="3"  border>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="中文名" prop="chineseName">
          {{ infoContent.chineseName }}
        </el-descriptions-item>
        <el-descriptions-item label="学名" prop="scientificName">
          {{ infoContent.scientificName }}
        </el-descriptions-item>
        <el-descriptions-item label="分布" prop="distribution">
          {{ infoContent.distribution }}
        </el-descriptions-item>
        <el-descriptions-item label="生境" prop="habitat">
          {{ infoContent.habitat }}
        </el-descriptions-item>
        <el-descriptions-item label="备注" prop="note">
          {{ infoContent.note }}
        </el-descriptions-item>
        <el-descriptions-item label="文献" prop="document">
          {{ infoContent.document }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
          {{ infoContent.createTime }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="endemicPlantInfo-sm">
      <el-descriptions class="margin-top" :title="this.title + '详情'" style="text-align: center"  :column="3"  border>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="中文名" prop="chineseName">
          {{ infoContent.chineseName }}
        </el-descriptions-item>
        <el-descriptions-item label="学名" prop="scientificName">
          {{ infoContent.scientificName }}
        </el-descriptions-item>
        <el-descriptions-item label="分布" prop="distribution">
          {{ infoContent.distribution }}
        </el-descriptions-item>
        <el-descriptions-item label="生境" prop="habitat">
          {{ infoContent.habitat }}
        </el-descriptions-item>
        <el-descriptions-item label="备注" prop="note">
          {{ infoContent.note }}
        </el-descriptions-item>
        <el-descriptions-item label="文献" prop="document">
          {{ infoContent.document }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
          {{ infoContent.createTime }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
export default {
  name: "endemicPlantInfo",
  props: {
    infoContent: Object,
    title: String
  },

}
</script>

<style scoped lang="scss">
.endemicPlantInfo {
  .endemicPlantInfo-lg {
    display: block;
  }
  .endemicPlantInfo-sm {
    display: none;
  }
}
::v-deep .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
  text-align: center !important;
}
@media screen and (max-width: 1200px) {
  .endemicPlantInfo {
    .wildPlantInfo-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .endemicPlantInfo {
    .endemicPlantInfo-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .endemicPlantInfo {
    .endemicPlantInfo-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .endemicPlantInfo {
    .endemicPlantInfo-lg {
      display: none;
    }
    .endemicPlantInfo-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
